import React, { useEffect } from "react";

const FeedbackDetailModal = ({
  isOpen,
  onClose,
  isDarkMode,
  title,
  subtitle,
  rows = [],
  columns = [],
  emptyLabel = "Aucune donnee disponible",
  closeLabel = "Fermer",
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const rowBg = isDarkMode ? "odd:bg-gray-900/40 hover:bg-gray-700/35" : "odd:bg-slate-50/70 hover:bg-slate-100/80";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6">
      <button
        type="button"
        aria-label={closeLabel}
        onClick={onClose}
        className="absolute inset-0 bg-black/50"
      />
      <div
        role="dialog"
        aria-modal="true"
        className={`relative flex max-h-[85vh] w-full max-w-4xl flex-col overflow-hidden rounded-2xl border shadow-2xl ${
          isDarkMode ? "border-gray-700 bg-gray-900 text-gray-100" : "border-gray-200 bg-white text-gray-900"
        }`}
      >
        <div className={`border-b px-5 py-4 ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
          <div className="flex items-start justify-between gap-4">
            <div>
              <h3 className="text-lg font-semibold">{title}</h3>
              {subtitle ? (
                <p className={`mt-1 text-sm ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}>{subtitle}</p>
              ) : null}
            </div>
            <button
              type="button"
              onClick={onClose}
              className={`rounded-lg px-3 py-1.5 text-sm font-medium transition ${
                isDarkMode ? "bg-gray-800 text-gray-200 hover:bg-gray-700" : "bg-slate-100 text-slate-700 hover:bg-slate-200"
              }`}
            >
              {closeLabel}
            </button>
          </div>
        </div>

        <div className="overflow-auto p-4">
          {rows.length === 0 ? (
            <p className={`rounded-xl px-4 py-6 text-center text-sm ${isDarkMode ? "bg-gray-800/70 text-gray-400" : "bg-slate-50 text-slate-500"}`}>
              {emptyLabel}
            </p>
          ) : (
            <table className="min-w-full text-sm">
              <thead className={isDarkMode ? "text-gray-400" : "text-gray-500"}>
                <tr>
                  {columns.map((column) => (
                    <th key={column.key} className={`px-3 py-2 text-left text-xs font-medium uppercase tracking-wide ${column.headerClassName || ""}`}>
                      {column.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr
                    key={row.id || `${row.playerId || row.playerName || "row"}-${index}`}
                    className={`transition-colors ${rowBg}`}
                  >
                    {columns.map((column) => (
                      <td key={column.key} className={`px-3 py-2 align-top ${column.className || ""}`}>
                        {typeof column.render === "function" ? column.render(row) : row[column.key] ?? "-"}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeedbackDetailModal;
